<template>
  <EasyDataTable
    :headers="instructionFields"
    :items="instructions"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
    <template #item-languages="item">
      <span v-for="content in item.translations" :key="content.countryCode">
        <span :class="'flagItem flag-icon flag-icon-' + content.countryCode"></span>
      </span>
    </template>
    <template #item-selected="item">
      <b-form-checkbox v-model="item.selected">
      </b-form-checkbox>
    </template>
    <template #item-isStandardInstruction="item">
      <span v-show="item.isStandardInstruction" class="fa fa-check"></span>
    </template>
    <template #item-buttons="item">
      <b-button
                @click.stop="$emit('beforeEditInstruction', item)"
                size="sm"
                class="fa fa-edit"
                v-if="allowEdit">
      </b-button>
      <b-form-checkbox v-else v-model="item.selected">
      </b-form-checkbox>
    </template>
  </EasyDataTable>
</template>

<script>
export default {
  name: 'instructions-table',
  props: {
    instructions: {},
    allowEdit: false
  },
  computed: {
    instructionFields() {
      var fields = [
        { value: 'name', text: this.$t('name'), sortable: true },
        {
          value: 'questionFormat',
          text: this.$t('privatePage.questionFormat_header'),
          sortable: true
        },
        { value: 'languages', text: this.$t('lang') },
        {
          value: 'isStandardInstruction',
          text: this.$t('privatePage.isStandardInstruction')
        }
      ]

      if (this.allowEdit) {
        fields.push({
          value: 'buttons',
          text: ' ',
          tdClass: 'rightAlignedField'
        })
      } else {
        fields.push({
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true
        })
      }

      return fields
    }
  }
}
</script>

<style scoped>
.flagItem {
  margin-right: 2px;
}
</style>
